import React, { useEffect } from 'react'
import { useAuth } from '../../features/auth/hooks'
import LoginLayout from '../../features/auth/layout/LoginLayout'
import Button from '../../common/components/atom/Button/Button'
import useNavigationApp from '../../navigation/useNavigationApp'

export default function ErrorPage({title = "Oops, une erreur", description = "Désolé une erreur est subvenue. Veuillez réessayer ulterieurement", withLogOutBtn}: {title?: string, description?: string, withLogOutBtn?: boolean}) {
    const  navigate = useNavigationApp()
    const {isLogged, logOutUser} = useAuth()
    useEffect(() => {
      if (!isLogged) {
        navigate.redirectToLoginPage()
      }
    })
    return (
      <LoginLayout centered>
        <h1>{title}</h1>
        <p>{description}</p>
        <div style={{height: 100}}/>
        <Button label="Retourner à l'accueil" linkTo='/' />
        <div style={{height: 50}}/>
        {withLogOutBtn && <Button onClick={logOutUser} variant='gray' label='Se déconnecter'/>}
      </LoginLayout>
    )
}
